import React from 'react';
import Main from './components/pages/Main';
import NotFound from './components/pages/NotFound';
import LoginForm from './components/login/LoginForm';
import { LayoutBlank, LayoutMain } from './components/layout/Layout';
import About from './components/pages/About';
import { Trans } from '@lingui/macro';
import SocialObjects from './components/pages/SocialObjects';
import Employment from './components/pages/Employment';
import Documents from './components/pages/Documents';
import MonitoringsReports from './components/pages/MonitoringsReports';
import ForParents from './components/pages/ForParents';
import ForSpecialists from './components/pages/ForSpecialists';
import Ask from './components/pages/Ask';
import SettingsForSpecialists from './components/pages/SettingsForSpecialists';
import Events from './components/pages/Events';
import Config from './components/pages/Config';
import MyQuestions from './components/pages/MyQuestions';
import QuestionsToMe from './components/pages/QuestionsToMe';
import StartOfPassReset from './components/login/StartOfPassReset';
import PasswordReset from './components/login/PasswordReset';
import Feedback from './components/pages/Feedback';
import DistanceTeacher from './components/pages/DistanceTeacher';
import DistanceTeacherExpert from './components/pages/DistanceTeacherExpert';
import DistanceTeacherParticipant from './components/pages/DistanceTeacherParticipant';
import ForParentsRecs from './components/pages/ForParentsRecs';
import ForParentsRecsNos from './components/pages/ForParentsRecsNos';
import ForParentsRecsFromId from './components/pages/ForParentsRecsFromId';
import ForParentsLits from './components/pages/ForParentsLits';
import ForSpecialistsRecs from './components/pages/ForSpecialistsRecs';
import ForSpecialistsMaterials from './components/pages/ForSpecialistsMaterials';
import ForSpecialistsRecsNos from './components/pages/ForSpecialistsRecsNos';
import ForSpecialistsRecsFromId from './components/pages/ForSpecialistsRecsFromId';
import DocumentsByPoint from './components/pages/DocumentsByPoint';
import { EventPage } from './components/pages/EventPage';
import AlumniVideos from './components/pages/AlumniVideos';
import { AlumniVideoPage } from './components/pages/AlumniVideoPage';
import ProfessionsAtlas from "./components/pages/ProfessionsAtlas";
import AnswerQuestion from "./components/pages/AnswerQuestion";
import ASDSocialObjects from "./components/pages/ASDSocialObjects";


//компоненты со ссылками
// eslint-disable-next-line import/no-anonymous-default-export
export default [
    // {path: '/', element: <LayoutMain children={<Main />} />},
    { path: '/', element: <LayoutMain children={<Events />} /> },
    { path: '/event/:eventId', element: <LayoutMain children={<EventPage />} /> },
    { path: '/alumni_videos', element: <LayoutMain children={<AlumniVideos />} /> },
    { path: '/alumni_videos/:videoId', element: <LayoutMain children={<AlumniVideoPage />} /> },
    { path: '/social', element: <LayoutMain children={<SocialObjects />} /> },
    { path: '/employment', element: <LayoutMain children={<Employment />} /> },
    { path: '/documents', element: <LayoutMain children={<Documents />} /> },
    { path: '/documents/:point', element: <LayoutMain children={<DocumentsByPoint />} /> },
    { path: '/reports', element: <LayoutMain children={<MonitoringsReports />} /> },
    { path: '/parents', element: <LayoutMain children={<ForParents />} /> },
    { path: '/parents/recs', element: <LayoutMain children={<ForParentsRecs />} /> },
    { path: '/parents/lits', element: <LayoutMain children={<ForParentsLits />} /> },
    { path: '/parents/recs/:nos', element: <LayoutMain children={<ForParentsRecsNos />} /> },
    { path: '/parents/recs/:nos/:recId', element: <LayoutMain children={<ForParentsRecsFromId />} /> },
    { path: '/specialist', element: <LayoutMain children={<ForSpecialists />} /> },
    { path: '/specialist/recs', element: <LayoutMain children={<ForSpecialistsRecs />} /> },
    { path: '/specialist/materials', element: <LayoutMain children={<ForSpecialistsMaterials />} /> },
    { path: '/specialist/recs/:nos', element: <LayoutMain children={<ForSpecialistsRecsNos />} /> },
    { path: '/specialist/recs/:nos/:recId', element: <LayoutMain children={<ForSpecialistsRecsFromId />} /> },
    { path: '/ask', element: <LayoutMain children={<Ask />} /> },
    { path: '/my_questions', element: <LayoutMain children={<MyQuestions />} /> },
    { path: '/questions_to_me', element: <LayoutMain children={<QuestionsToMe />} /> },
    { path: '/about', element: <LayoutMain children={<About />} /> },
    { path: '/settingsforspecialist', element: <LayoutMain children={<SettingsForSpecialists />} /> },
    { path: '*', element: <LayoutMain children={<NotFound />} /> },
    { path: '/login', element: <LayoutBlank children={<LoginForm />} /> },
    { path: '/reset_pass', element: <LayoutBlank children={<StartOfPassReset />} /> },
    { path: '/reset_pass/:uid/:token', element: <LayoutBlank children={<PasswordReset />} /> },
    { path: '/config', element: <LayoutMain children={<Config />} /> },
    { path: '/feedback', element: <LayoutMain children={<Feedback />} /> },
    { path: '/distant', element: <LayoutBlank children={<DistanceTeacher />} /> },
    { path: '/distant/expert', element: <LayoutBlank children={<DistanceTeacherExpert />} /> },
    { path: '/distant/participant', element: <LayoutBlank children={<DistanceTeacherParticipant />} /> },
    { path: '/professions-atlas', element: <LayoutMain children={<ProfessionsAtlas />}  /> },
    { path: '/answer-question', element: <LayoutMain children={<AnswerQuestion />}  /> },
    { path: '/asd-schools', element: <LayoutMain children={<SocialObjects />}  /> },
    { path: '/asd-organizations', element: <LayoutMain children={<ASDSocialObjects />}  /> },
];

//меню
export const menu = [
    { path: '/', component: Main, title: <Trans>Main</Trans> },
    { path: '/about', component: About, title: <Trans>About</Trans> },
];

export const dropdownMenu = [
    // { path: '/', component: Events, title: <Trans>Events</Trans> },
    // {path: '/social', component: SocialObjects, title: <Trans>Social objects</Trans>},
    // {path: '/employment', component: Employment, title: <Trans>Employment</Trans>},
    { path: '/documents', component: Documents, title: <Trans>Documents</Trans> },
    // {path: '/reports', component: MonitoringsReports, title: <Trans>Monitorings, reports</Trans>},
    { path: '/parents', component: ForParents, title: <Trans>For parents</Trans> },
    { path: '/specialist', component: ForSpecialists, title: <Trans>For specialists</Trans> },
    { path: '/alumni_videos', component: AlumniVideos, title: <Trans>Proud of you, our graduate!</Trans> },
    // { path: '/professions-atlas', component: ProfessionsAtlas, title: <Trans>Atlas of professions</Trans> },
    // { path: '/answer-question', component: AnswerQuestion, title: <Trans>Answer-Question</Trans> },
];
